var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "d-flex flex-column align-center mb-12"
  }, [_c('h1', {
    staticClass: "text-h2 text-center primary--text font-weight-bold"
  }, [_vm._v(" Career Counselor ")]), _c('v-card', {
    staticClass: "rounded-lg mt-12",
    attrs: {
      "max-width": "800px",
      "width": "100%"
    }
  }, [_c('v-card-text', {
    staticClass: "primary--text"
  }, [_c('img', {
    staticClass: "d-block my-4 rounded mx-auto",
    attrs: {
      "height": "200px",
      "width": "300px",
      "src": "https://media.eipl.org/site/images/services/career-counselor.jpg"
    }
  }), _c('p', {
    staticClass: "text-body-1 primary--text font-weight-black my-8"
  }, [_vm._v(" A trained Career Counselor is available by appointment for a one-on-one interview with any adult resident of the East Islip Library District. ")]), _c('p', {
    staticClass: "text-body-1 primary--text text--lighten-2 font-weight-bold mb-4"
  }, [_vm._v(" You will be able to receive help with writing a resume and cover letter, preparing for a job interview, exploring career changes and more. ")]), _c('p', {
    staticClass: "primary-text mb-0 mt-10"
  }, [_vm._v(" Call the reference desk to make an appointment (581-9200 x 5) ")]), _c('button-phone', {
    staticClass: "mt-4"
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }